import { makeStyles, theme } from "cdh-data-portal-theme"

export const useStyles = makeStyles()(() => ({
  card: {
    background: theme.colors.globalBackgroundLight,
    borderRadius: 4,
    boxShadow: theme.shadows.medium,
    display: "grid",
    gap: 20,
    gridTemplateColumns: "repeat(3, minmax(0, 1fr)) auto",
    padding: 20,
  },
  cardAction: {
    alignSelf: "start",
    gridColumn: 4,
    gridRow: "1 / span 2",
  },
  cardList: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 16,
  },
  detail: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  dialogDescription: {
    marginBottom: 16,
  },
  search: {
    marginTop: 24,
    maxWidth: 360,
  },
}))
